import React from 'react';
import VoipCall from "../VoipCall";

const VoipCallModal = ({ data, orderId, onClose, phoneToCall }) => {
    return (
        <div className="voip-modal-overlay">
            <div className="voip-modal-content">
                <button className="close-btn" onClick={onClose}>✕</button>
                <VoipCall data={data} onClose={onClose} orderId={orderId} phoneToCall={phoneToCall} />
            </div>
        </div>
    );
};

export default VoipCallModal;
